import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubQueryKeys } from "../club";
import { clubAsPublicQueryKeys } from "../clubAsPublic";

export function useMutationStripeCompleteOnboard({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.clubApi.stripeCompleteOnboard(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clubQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: clubAsPublicQueryKeys.all() });
    },
  });
}
